import React from 'react';

interface IconPlusCircleProps {
    iconClasses?: string;
}

const IconPlusCircle: React.FC<IconPlusCircleProps> = ({ iconClasses }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-plus-circle ${iconClasses ?? ''}`}
        >
            <g clipPath="url(#clip0_92_1115)">
                <path
                    d="M11.9996 24C8.79961 24 5.79961 22.8 3.49961 20.5C-1.20039 15.8 -1.20039 8.2 3.49961 3.5C5.79961 1.2 8.79961 0 11.9996 0C15.1996 0 18.1996 1.2 20.4996 3.5C25.1996 8.2 25.1996 15.8 20.4996 20.5C18.1996 22.8 15.1996 24 11.9996 24ZM11.9996 2C9.29961 2 6.79961 3 4.89961 4.9C0.999609 8.8 0.999609 15.2 4.89961 19.1C6.79961 21 9.29961 22 11.9996 22C14.6996 22 17.1996 21 19.0996 19.1C22.9996 15.2 22.9996 8.9 19.0996 5C17.1996 3 14.6996 2 11.9996 2Z"
                    fill="currentColor"
                />
                <path
                    d="M12 18C11.4 18 11 17.6 11 17V7C11 6.4 11.4 6 12 6C12.6 6 13 6.4 13 7V17C13 17.6 12.6 18 12 18Z"
                    fill="currentColor"
                />
                <path
                    d="M17 13H7C6.4 13 6 12.6 6 12C6 11.4 6.4 11 7 11H17C17.6 11 18 11.4 18 12C18 12.6 17.6 13 17 13Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_92_1115">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconPlusCircle;
